import React from 'react';
import { Meteor } from 'meteor/meteor';
import { Reservations } from '../../collections/reservations/reservations';
import moment from 'moment';
import { reservationsCancelSMS } from '../../collections/statistics/reservations';

const Papa = require('papaparse');
const FileSaver = require('file-saver');
const utf8 = require('utf8');
import { Tracker } from 'meteor/tracker';

import {
	Row,
	Col,
	Grid,
	Panel,
	PanelBody,
	PanelContainer,
	Button,
	ButtonToolbar,
  FormGroup,
  ControlLabel,
  FormControl
} from '@sketchpixy/rubix';

import { Reactive } from '../common/Reactive.mixin.js';
import { PanelHeader } from '@sketchpixy/rubix/lib/Panel';
var DatePicker = require("react-bootstrap-date-picker");

@Reactive({
	subscriptions: [{name: 'reservations', paginate: true}]
})
export default class SMSPage extends React.Component {

	constructor(props) {
		super(props);
    this.state = {};

    this.state.startDate = moment().subtract(15, 'days').toDate();
    this.state.selectedDate = moment().format();
    this.state.selectPeriod = 'Matin';
    this.state.passengers = [];
    this.state.reservations = [];
    this.state.selectedReservations = [];

    // props.ready.then(() => {
		// 	Tracker.autorun(() => {
		// 		this.setState({
		// 			'reservations' : Reservations.find({
    //         updatedAt: {
    //             $gte: this.state.startDate
    //           },
    //       }).fetch(),
		// 		});

    //     //count number of sms :
    //     let selectedPassengers = [];
    //     let selectedReservations = [];
    //     this.state.reservations.forEach(reservation => {
    //       if(reservation.history) {

    //         let history = reservation.history.slice(-1).pop();
    //         if(history) {
    //           if(history.type == 'cancelled') {
    //           const passengers = reservation.getPassengers();
    //           passengers.forEach(passenger => {
    //             if(passenger.phone) {
    //               selectedPassengers.push(passenger);
    //             }
    //           });
    //           selectedReservations.push(reservation);
    //         }}


    //       }

    //     });

    //     this.setState({'passengers': selectedPassengers});
    //     this.setState({'selectedReservations': selectedReservations});

		// 	});
    // });

	}

  loadCancelReservations() {
    this.setState({'pendingCancelAll': true});
		reservationsCancelSMS.call(((err, results) => {
				this.setState({'pendingCancelAll': false});
        this.setState({reservations: results});

        let selectedPassengers = [];
        this.state.reservations.forEach(reservation => {
          reservation.passengers.forEach(passenger => {
            if(passenger.phone) {
              selectedPassengers.push(passenger);
            }
          });
        });

        this.setState({'passengers': selectedPassengers});
			}).bind(this));
  }

  downloadFile(file, name) {

		var csvData = new Blob(["\uFEFF"+file], {
		type: 'text/csv; charset=utf-18'
		});
		var csvURL = window.URL.createObjectURL(csvData);
		var tempLink = document.createElement('a');
		tempLink.href = csvURL;
		tempLink.setAttribute('download', name + '.csv');
		tempLink.click();
	}

  selectPeriod(ref) {
    this.setState({
      selectPeriod: ref.target.value
    });
  }

  sendNexmoSMS(message, phone) {

    phone = phone.slice(1);;
    phone = phone.replace(' ', '');
    phone = phone.replace('.', '');
    phone = '33' + phone;

    console.log('phone', phone);

    if(phone[2] == '6' || phone[2] == '7') {
        Meteor.call('send.sms', {
          'to': phone,
          'message': message,
        });
    }
  }

  sendSMS() {

    const message = `Bonjour,
    Un nouveau créneau de vol est disponible le ${moment(this.state.selectedDate).format('DD/MM/YYYY')} - ${this.state.selectPeriod}.
    Si vous souhaitez réserver ce créneau, merci de nous appeler rapidement au 02 41 404 804.
    `;

    if(confirm('Êtes-vous sûr de vouloir envoyer ces sms ?')) {
      this.state.passengers.forEach(passenger => {
        this.sendNexmoSMS(message, passenger.phone, 'TEST1234');
      });

      alert('SMS envoyés !');
    }
  }

	render() {
		return (
			<div>
				<PanelContainer>
					<Panel>
						<PanelHeader className='bg-blue'>
							<Grid>
							<Row>
								<Col xs={12} className='fg-white'>
									<h3>Notifier par SMS</h3>
                  <p>Envoyer un SMS aux passagers dont la réservation a été annulée sur les 15 derniers jours afin de les notifier qu'une date est disponible.</p>
								</Col>
							</Row>
							</Grid>
						</PanelHeader>
						<PanelBody style={{padding: 20}}>


            <Button bsStyle="primary" onClick={this.loadCancelReservations.bind(this)}>Charger les réservations</Button><br/><br/>


              {this.state.reservations &&
                <div>
                  <strong>Date proposée :</strong>
                  <DatePicker
                    dayLabels={['Dim', 'Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam']}
                    monthLabels={['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Aout', 'Septembre', 'Octobre', 'Novembre', 'Decembre']}
                    id="start_date" value={this.state.selectedDate} onChange={(value) => this.setState({ selectedDate: value })}/>
                  <br/>

                  <strong>Période proposée :</strong>
                  <FormControl componentClass="select" placeholder="select" ref="year" onChange={this.selectPeriod.bind(this)}>
                    <option >Matin</option>
                    <option>Soir</option>
                  </FormControl>
                  <br/>

                  <Button bsStyle="primary" onClick={this.sendSMS.bind(this)}>Envoyer les SMS</Button>

                  <br/><br/><br/>
                  <i>Infos :</i>
                  <br/><br/>
                  <span>Nombre de réservation : {this.state.reservations.length} réservations</span>
                  <br/>
                  <span>Nombre de SMS : {this.state.passengers.length} sms</span><br/><br/>
                  <div>
                    {this.state.reservations.map(reservation => {
                      return (
                        <span>{reservation.id_billet}<br/></span>
                      );
                    })}
                  </div>
                </div>
              }
              {!this.state.reservations &&
              <div>Chargement...</div>
              }
						</PanelBody>
					</Panel>
				</PanelContainer>
			</div>
		);
	}
}



/** WEBPACK FOOTER **
 ** ./src/universal/components/sms/Sms.page.js
 **/